<template>
  <div v-click-outside="closeOptions" class="search-bar">
    <input
      v-model="searchTerm"
      type="text"
      class="search-input"
      :placeholder="getPlaceholder()"
      @click="openOptions()"
      @keyup.enter="handleSearch"
    />
    <magnifying-glass class="search-icon"></magnifying-glass>
    <div v-if="showOptions" class="options-search-items">
      <div v-if="lastSearches?.length && searchTerm.length === 0">
        <div
          v-for="(search, index) in lastSearches"
          :key="index"
          class="option-search-item"
          @click="selectRecentSearch(search)"
        >
          <p>{{ search }}</p>
        </div>
      </div>
      <div
        v-else
        class="option-search-item"
        @click="emitSearchToParent(searchTerm)"
      >
        <p>Search products with "{{ searchTerm }}"</p>
      </div>
    </div>
  </div>
</template>

<script>
import MagnifyingGlass from "@/assets/svg/magnifying-glass.svg?inline";

export default {
  components: {
    MagnifyingGlass,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => [],
    },
  },
  data() {
    return {
      searchTerm: "",
      showOptions: false,
      lastSearches: [],
    };
  },
  watch: {
    searchTerm(newValue, oldValue) {
      if (oldValue && !newValue) {
        this.$emit("clear-search");
      }
    },
  },
  methods: {
    emitSearchToParent(searchTerm) {
      this.$emit("search", { productName: searchTerm });
      this.closeOptions();
    },
    openOptions() {
      this.showOptions = true;
    },
    closeOptions() {
      this.showOptions = false;
    },
    getPlaceholder() {
      return this.$t("productPages.searchBarPlaceholder");
    },
    selectRecentSearch(search) {
      this.searchTerm = search;
      this.handleSearch();
    },
    handleSearch() {
      if (this.searchTerm) {
        this.$emit("search", { productName: this.searchTerm });
        this.closeOptions();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-bar {
  position: relative;
  width: 50%;
}
.search-input {
  width: 100%;
  height: 30px;
  @include input-style;
  padding: 3px 8px 3px 8px;
  &::placeholder {
    color: rgba(196, 196, 196, 1);
    font-size: 12px;
  }
}
.search-icon {
  position: absolute;
  right: 8px;
  bottom: 6px;
}
.options-search-items {
  margin-top: 1px;
  border: 1px solid $light-grey;
  border-radius: 4px;
  position: absolute;
  z-index: 1000;
  background: white;
  width: 100%;
}

.option-search-item {
  cursor: pointer;
  @include base-font;
  @include font-smaller;
  color: $light-grey;
  padding: 4px 10px;
  text-align: left;
  &:hover {
    background: $settings-hover;
    color: $dark-grey;
  }
}
</style>
